import { Close } from "@mui/icons-material";
import { Dialog, IconButton, Typography } from "@mui/material";
import { styled } from "@mui/system";
import StyledButton from "../dashboard/StyledButton";
import { GenericModalConfig } from "../portfolio/hooks/useSumsubStatus";

// If mobile, full screen
export const ModalWrapper = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-container": {
    [theme.breakpoints.down("sm")]: {
      alignItems: "stretch",
    },
  },
  "& .MuiDialog-paper": {
    display: "flex",
    minWidth: "400px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "12px",
    borderRadius: "8px",
    background: "#FFF",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100%",
      width: "100%",
      maxWidth: "100% !important",
      height: "100vh",
      margin: 0,
      // Use dynamic viewport height on modern mobile browsers
      "@supports (height: 100dvh)": {
        height: "100dvh",
      },
      maxHeight: "none",
      borderRadius: "0px",
    },
  },
  background: "rgba(0, 32, 53, 0.7)",
}));

export const ModalHeader = styled("div")({
  fontSize: "23px",
  fontWeight: "700",
  padding: "16px 24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: "8px",
  alignSelf: "stretch",
  background: "#002035",
});

export const ModalContent = styled("div")({
  display: "flex",
  width: "100%",
  alignItems: "flex-start",
  padding: "24px",
});

const GenericModal = ({
  title,
  mainIssue = "Something went wrong",
  subIssue = ["Please contact support"],
  buttonText = "Close",
  open,
  onClose,
  buttonAction,
}: GenericModalConfig) => {
  return (
    <ModalWrapper open={open} onClose={onClose}>
      <ModalHeader>
        <Typography variant="h6" color={"white"}>
          {title}
        </Typography>
        {/* Close Button */}
        <IconButton onClick={onClose} sx={{ color: "white", position: "absolute", right: "16px" }}>
          <Close />
        </IconButton>
      </ModalHeader>
      {/* Bullet points text */}
      <ModalContent>
        <Typography variant="body1">{mainIssue}</Typography>
        <ul style={{ paddingLeft: "25px", marginTop: "8px" }}>
          {subIssue.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </ModalContent>
      {/* Button */}
      <div style={{ padding: "24px", width: "100%" }}>
        <StyledButton onClick={buttonAction}>{buttonText}</StyledButton>
      </div>
    </ModalWrapper>
  );
};

export default GenericModal;
